import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/api');

export interface CertificadoInfo {
  nomeTitular: string | null;
  nomeAgente: string | null;
  cpf: string | null;
  cnpj: string | null;
  numeroSerie: string | null;
  numeroCertificado: string | null;
  certificado: string | null;
  tipoCertificado: string | null;
  emissor: string | null;
  certificadora: string | null;
  dataValidadeInicio: string | null;
  dataExame: string | null;
  dataValidadeFim: string | null;
  dataValidade: string | null;
  situacao: string | null;
}

export interface ConsultaCertificadoResponse {
  sucesso: boolean;
  mensagem: string;
  cpf?: string;
  dados: CertificadoInfo[] | null;
  certificados?: CertificadoInfo[];
}

export default class CertificadoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async consultarPorCpf(cpf: string): Promise<ConsultaCertificadoResponse> {
    const cpfLimpo = cpf.replace(/\D/g, '');
    const response = await this.axios.get(`/certificado/consulta?cpf=${cpfLimpo}`);
    return response.data;
  }

  async consultarPorCpfPost(cpf: string): Promise<ConsultaCertificadoResponse> {
    const cpfLimpo = cpf.replace(/\D/g, '');
    const response = await this.axios.post(`/certificado/consulta`, { cpf: cpfLimpo });
    return response.data;
  }
}
